import { fetchEventSource } from "@microsoft/fetch-event-source";
import { Skeleton } from "primereact/skeleton";
import { Toast } from "primereact/toast";
import { useEffect, useRef, useState, useContext } from "react";
import { Calendar } from "primereact/calendar";
import moment from "moment";
import fileUpload from "../../services/fileUpload";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import CommunicationIcon from "./Images/communication-icon.svg";
import AnswerIcon from "./Images/vedbhoomilogo.png";
import authHeader from "../../services/authHeader";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { contextStore } from "../../context/CustomStateProvider";
import { useFormik } from "formik";
import { Button } from "primereact/button";
import { FileUpload } from "primereact/fileupload";
import { MultiSelect } from "primereact/multiselect";
import { marked } from "marked";
import { ProgressSpinner } from "primereact/progressspinner";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import protocolServices from "../../services/protocolServices";
import InventoryService from "../../services/InventoryService";

interface ChatResponse {
  id?: string;
  session_id?: string;
  conversation_id?: string;
  chat_id?: string;
  created_at?: string;
  question: string;
  answer: string;
  role?: string;
  transactionId?: string;
  isdietsaved?: boolean;
  loading?: boolean;
  sources?: {
    document_id: number;
    document_name: string;
  }[];
}
interface ChatHistoryItem {
  Question: string;
  Answer: string;
}
interface Conversation {
  convId: string;
  header: string;
  date: string;
  chats: ChatResponse[];
}

const theme = {
  primary: "#F58500",
  primaryHover: "#E67600",
  primarySoft: "#FFF3E0",

  accent: "#8A5C22",
  accentSoft: "#F9F1E7",

  textPrimary: "#3A2B10",
  textSecondary: "#6B5B4A",

  border: "#E6D8BF",

  background: "#FFFFFF",
  backgroundAlt: "#FFFBF4",
};

export default function ChatBot() {
  const context = useContext(contextStore);
  const location = useLocation();
  const [protocolData, setProtocolData] = useState<any>(null);
  const [question, setQuestion] = useState("");
  const [questionloading, setQuestionLoading] = useState(false);
  const [downloadingRecipeChatId, setDownloadingRecipeChatId] = useState<
    string | null
  >(null);
  const [chatResponses, setChatResponses] = useState<ChatResponse[]>([]);
  const resource = context.state.strings;
  const [uploadVisible, setUploadVisible] = useState(false);
  const [documentFileName, setDocumentFileName] = useState<string>("");
  const [progressForDocument, setProgressForDocument] = useState<number>(0);
  const [selectedDocuments, setSelectedDocuments] = useState<any[]>([]);
  const [documentOptions, setDocumentOptions] = useState<any[]>([]);
  const [selectedInventory, setSelectedInventory] = useState<any[]>([]);
  const [conversations, setConversations] = useState<Conversation[]>([]);
  const [selectedConversationId, setSelectedConversationId] = useState<
    string | null
  >(null);
  const [allChatHistory, setAllChatHistory] = useState<any[]>([]);
  const [groupedConversations, setGroupedConversations] = useState<any>({});
  const [isNewChatStarted, setIsNewChatStarted] = useState(false);
  const [openGroups, setOpenGroups] = useState<{ [key: string]: boolean }>({
    today: true,
    thisWeek: true,
    thisMonth: true,
    lastMonth: true,
    pastMonths: false,
  });
  const { marked } = require("marked");
  const toast: any = useRef(null);
  const textareaRef = useRef<HTMLTextAreaElement | null>(null);
  const chatContainerRef = useRef<HTMLDivElement>(null);
  const currentResponseIndex = useRef<number | null>(null);
  const { conversationId } = useParams<{ conversationId?: string }>();
  const hasStartedStreaming = useRef(false);
  const [showSkeleton, setShowSkeleton] = useState(true);
  const skeletonStartTime = useRef<number>(0);
  const prescriptionId = protocolData?.prescriptionId;
  const userId = protocolData?.userId;
  const dietstartdate = protocolData?.dietstartdate;
  const [currentConversationId, setCurrentConversationId] = useState<
    string | null
  >(null);
  const navigate = useNavigate();
  const [loadingSpinnerLayout, setLoadingSpinnerLayout] =
    useState<boolean>(true);
  const formatDateTime = (dateStr: string) => {
    const date = new Date(dateStr);
    return date.toLocaleString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  };

  const forceScrollToBottom = () => {
    const container = chatContainerRef.current;
    if (!container) return;

    container.scrollTo({
      top: container.scrollHeight,
      behavior: "smooth",
    });
  };

  const isUserAtBottom = () => {
    const container = chatContainerRef.current;
    if (!container) return true;

    return (
      container.scrollHeight - container.scrollTop - container.clientHeight < 20
    );
  };

  const truncateText = (text: string, length = 35) =>
    text.length > length ? text.slice(0, length) + "..." : text;

  const hasTable = (text: string) => {
    if (!text) return false;
    return /\|.+\|\n\|[-\s|:]+\|/.test(text);
  };
  useEffect(() => {
    if (conversationId) {
      // URL controls the conversation
      setSelectedConversationId(conversationId);
      setCurrentConversationId(conversationId);
      setIsNewChatStarted(false);
    } else {
      // New chat when no ID in URL (e.g. "Generate Diet" / "+ New Chat")
      const newConvId = crypto.randomUUID();
      setCurrentConversationId(newConvId);
      setSelectedConversationId(newConvId);
      setIsNewChatStarted(true);
    }
  }, [conversationId]);

  // useEffect(() => {
  //   if (protocolData?.prescriptionId) {
  //     fetchAllHistory();
  //   }
  // }, [protocolData]);
  useEffect(() => {
    if (protocolData?.userId) {
      fetchAllHistory();
    }
  }, [protocolData]);

  useEffect(() => {
    const fetchPDFList = async () => {
      try {
        const response: any = await fileUpload.GetAllPDFMaster();

        if (response?.status === 200 && Array.isArray(response.data)) {
          const pdfList = response.data.map((item: any) => ({
            name: item.pdfName,
            code: item.pdfid,
          }));
          setDocumentOptions(pdfList);
          // setSelectedDocuments([pdfList[0]]);
        } else {
          toast.current?.show({
            severity: "warn",
            summary: "No Documents",
            detail: "No documents found for this user.",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error fetching PDF list:", error);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to load documents.",
          life: 3000,
        });
      }
    };

    fetchPDFList();
  }, []);

  useEffect(() => {
    const fetchInventoryList = async () => {
      try {
        const response: any = await InventoryService.GetAllInventoryMaster();

        if (response?.status === 200 && Array.isArray(response.data)) {
          const inventoryList = response.data.map((item: any) => ({
            code: item.inventoryid,
            expiryDate: item.inventoryexpirydate,
          }));
          setSelectedInventory(inventoryList);
        } else {
          toast.current?.show({
            severity: "warn",
            summary: "No Inventory",
            detail: "No inventory documents found for this user.",
            life: 3000,
          });
        }
      } catch (error) {
        console.error("Error fetching inventory list:", error);
        toast.current?.show({
          severity: "error",
          summary: "Error",
          detail: "Failed to load inventory documents.",
          life: 3000,
        });
      }
    };

    fetchInventoryList();
  }, []);

  const onBackButtonClick = () => {
    localStorage.removeItem("protocol_chatbot_data"); //for clearing the protocol data on back button click
    navigate("/protocol");
  };

  useEffect(() => {
    // Read passed state OR fallback to localStorage
    if (location.state) {
      setProtocolData(location.state);
      localStorage.setItem(
        "protocol_chatbot_data",
        JSON.stringify(location.state),
      );
    } else {
      const saved = localStorage.getItem("protocol_chatbot_data");
      if (saved) setProtocolData(JSON.parse(saved));
    }
  }, [location.state]);

  const startNewConversation = () => {
    const newConvId = crypto.randomUUID();
    setCurrentConversationId(newConvId);
    setSelectedConversationId(newConvId);
    setIsNewChatStarted(true);
    setQuestion("");

    setTimeout(() => {
      textareaRef.current?.focus();
    }, 100);
  };
  const isNewChatEmpty =
    isNewChatStarted &&
    !loadingSpinnerLayout &&
    !chatResponses.some(
      (chat) => chat.conversation_id === selectedConversationId,
    );
  const hasNoHistory = !loadingSpinnerLayout && chatResponses.length === 0;

  // ✅ Updated grouping function
  const groupConversations = (chats: ChatResponse[]) => {
    const groupedByConv: { [convId: string]: ChatResponse[] } = {};

    chats.forEach((chat) => {
      if (!groupedByConv[chat.conversation_id!])
        groupedByConv[chat.conversation_id!] = [];
      groupedByConv[chat.conversation_id!].push(chat);
    });

    // Sort each chat list by created_at ascending
    Object.values(groupedByConv).forEach((chats) =>
      chats.sort(
        (a, b) =>
          new Date(a.created_at!).getTime() - new Date(b.created_at!).getTime(),
      ),
    );

    const convArray = Object.entries(groupedByConv).map(([convId, chats]) => {
      const firstChat = chats[0];
      const lastChat = chats[chats.length - 1];
      return {
        convId,
        header: firstChat?.question || "Untitled Chat",
        // ✅ Updated date — latest message
        date: lastChat?.created_at
          ? formatDateTime(lastChat.created_at)
          : "Unknown Date",
        chats,
      };
    });

    // ✅ Sort by latest activity — recent chats on top
    convArray.sort(
      (a, b) =>
        new Date(b.chats[b.chats.length - 1].created_at!).getTime() -
        new Date(a.chats[a.chats.length - 1].created_at!).getTime(),
    );

    // Group into categories
    const now = new Date();
    const startOfToday = new Date(now);
    startOfToday.setHours(0, 0, 0, 0);

    const startOfThisMonth = new Date(now.getFullYear(), now.getMonth(), 1);

    // Rolling 7 days back from today, but never crossing into the previous month.
    let startOfWeek = new Date(startOfToday);
    startOfWeek.setDate(startOfWeek.getDate() - 7);
    if (startOfWeek < startOfThisMonth) startOfWeek = startOfThisMonth;

    const startOfLastMonth = new Date(now.getFullYear(), now.getMonth() - 1, 1);

    const groups: any = {
      today: [],
      thisWeek: [],
      thisMonth: [],
      lastMonth: [],
      pastMonths: [],
    };

    convArray.forEach((conv) => {
      const convDate = new Date(
        conv.chats[conv.chats.length - 1]?.created_at || "",
      );
      if (convDate >= startOfToday) groups.today.push(conv);
      else if (convDate >= startOfWeek) groups.thisWeek.push(conv);
      else if (convDate >= startOfThisMonth) groups.thisMonth.push(conv);
      else if (convDate >= startOfLastMonth) groups.lastMonth.push(conv);
      else groups.pastMonths.push(conv);
    });

    setGroupedConversations(groups);
  };

  const fetchAllHistory = async () => {
    // if (!prescriptionId) return;
    if (!userId) {
      setLoadingSpinnerLayout(false);
      return;
    }
    try {
      setLoadingSpinnerLayout(true);

      const resp = await fetch(
        // `https://cc4jaxi5vi.execute-api.ap-south-1.amazonaws.com/Prod/chat/by-customer/${userId}`,
        `https://chataiapi-dev.vedbhoomi.co.in/chat/by-customer/${userId}`,
        // `http://127.0.0.1:8000/chat/by-customer/${userId}`,
        {
          headers: {
            "Content-Type": "application/json",
            ...authHeader(),
          },
        },
      );

      if (!resp.ok) {
        console.error("Failed to fetch chat history", resp.status);
        return;
      }
      const data = await resp.json();

      const history: ChatResponse[] = data.map((item: any) => ({
        id: item.id,
        session_id: item.session_id,
        conversation_id: item.conversation_id,
        chat_id: item.chat_id,
        // prescription_id: item.prescription_id,
        customer_user_id: item.customer_user_id,
        question: item.question,
        answer: item.answer || "",
        sources: item.sources || [],
        role: item.role,
        created_at: item.created_at,
        isdietsaved: item.isdietsaved || false,
      }));

      setChatResponses(history);
      groupConversations(history);
    } catch (err) {
      console.error("Error fetching chat history:", err);
    } finally {
      setLoadingSpinnerLayout(false);
    }
  };

  useEffect(() => {
    fetchAllHistory();
    adjustTextareaHeight();
  }, []);

  const adjustTextareaHeight = () => {
    const textarea = textareaRef.current;
    if (!textarea) return;

    textarea.style.height = "44px";
    if (textarea.scrollHeight > 44) {
      textarea.style.height = Math.min(textarea.scrollHeight, 160) + "px";
    }
  };

  const scrollToBottomForAnswer = () => {
    const container = chatContainerRef.current;
    if (!container) return;

    if (isUserAtBottom()) {
      container.scrollTo({
        top: container.scrollHeight,
        behavior: "smooth",
      });
    }
  };

  const onQuestionChange = (e: any) => {
    setQuestion(e.target.value);
    adjustTextareaHeight();
  };

  const onEnterClick = (e: any) => {
    // if (e.keyCode === 13) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      sendQuestion(question);
    }
  };

  const sendQuestion = async (que: string) => {
    if (!que.trim()) return;
    if (questionloading) {
      return;
    }
    setQuestionLoading(true);
    hasStartedStreaming.current = false;
    setShowSkeleton(true);
    skeletonStartTime.current = Date.now();

    const activeConvId =
      selectedConversationId || currentConversationId || crypto.randomUUID();

    const newQuestion: ChatResponse = {
      question: que,
      answer: "",
      created_at: new Date().toISOString(),
      conversation_id: activeConvId,
    };

    // Initialize a reference to prevent double streams
    const streamActiveRef = { active: true };
    // Add new question immediately
    setChatResponses((prev) => {
      const updated = [...prev, newQuestion];
      currentResponseIndex.current = updated.length - 1;
      setTimeout(forceScrollToBottom, 0);
      return updated;
    });

    // Update sidebar
    setGroupedConversations((prevGroups: any) => {
      const updatedGroups = { ...prevGroups };

      const allConvs = [
        ...(prevGroups.today || []),
        ...(prevGroups.thisWeek || []),
        ...(prevGroups.thisMonth || []),
        ...(prevGroups.lastMonth || []),
        ...(prevGroups.pastMonths || []),
      ];

      const existingConv = allConvs.find((c: any) => c.convId === activeConvId);
      const newHeader = existingConv?.header || que;

      const newConv = {
        convId: activeConvId,
        header: newHeader,
        date: formatDateTime(new Date().toISOString()),
        chats: [...(existingConv?.chats || []), newQuestion],
      };

      Object.keys(updatedGroups).forEach((k) => {
        updatedGroups[k] = updatedGroups[k].filter(
          (conv: any) => conv.convId !== activeConvId,
        );
      });

      updatedGroups.today = [newConv, ...(updatedGroups.today || [])];
      return updatedGroups;
    });
    let chat_history: ChatHistoryItem[] = [];

    chatResponses
      .filter((response) => response.conversation_id === activeConvId)
      .forEach((response) => {
        chat_history.push({
          Question: response.question,
          Answer: response.answer,
        });
      });

    chat_history.push({ Question: que, Answer: "" });

    setQuestion("");

    setTimeout(() => {
      adjustTextareaHeight();
    }, 0);

    const ctrl = new AbortController();
    const document_ids = selectedDocuments.map((doc) => doc.code);
    const inventory_ids = selectedInventory.map((inv) => inv.code);
    const inventory_expiry_date = selectedInventory[0]?.expiryDate;
    let fullResponse = "";

    try {
      await fetchEventSource(
        // "https://cc4jaxi5vi.execute-api.ap-south-1.amazonaws.com/Prod/ask",
        "https://chataiapi-dev.vedbhoomi.co.in/ask",
        // "http://127.0.0.1:8000/ask",
        {
          method: "POST",
          body: JSON.stringify({
            question: que,
            top_k: 5,
            conversation_id: activeConvId,
            document_ids,
            inventory_ids,
            inventory_expiry_date,
            chat_history: chat_history,
            // prescription_id: prescriptionId,
            customer_user_id: userId,
          }),
          headers: {
            "Content-Type": "application/json",
            ...authHeader(),
          },
          signal: ctrl.signal,
          // Keep the connection alive when the tab is hidden, otherwise
          // fetch-event-source aborts and reopens (re-POSTs) the request,
          // which makes the diet regenerate from day 1.
          openWhenHidden: true,
          onopen: async (response: Response) => {
            if (!response.ok) {
              // Non-2xx: stop here, do not let the library retry.
              throw new Error(`Stream failed: ${response.status}`);
            }
          },
          onmessage: (event: any) => {
            if (!streamActiveRef.active) {
              return;
            }

            if (!event.data) return;
            try {
              const parsed = JSON.parse(event.data);
              const newChunk = parsed.response || "";

              if (parsed.streaming !== false && !newChunk) return;
              if (parsed.streaming !== false) {
                if (!hasStartedStreaming.current) {
                  hasStartedStreaming.current = true;
                  const elapsed = Date.now() - skeletonStartTime.current;
                  const MIN_SKELETON_TIME = 250;

                  if (elapsed >= MIN_SKELETON_TIME) {
                    setShowSkeleton(false);
                  } else {
                    setTimeout(
                      () => setShowSkeleton(false),
                      MIN_SKELETON_TIME - elapsed,
                    );
                  }
                }

                fullResponse += newChunk;

                const idx = currentResponseIndex.current;
                if (idx !== null) {
                  setChatResponses((prev) => {
                    const updated = [...prev];
                    updated[idx] = {
                      ...updated[idx],
                      answer: fullResponse,
                    };
                    return updated;
                  });
                  requestAnimationFrame(scrollToBottomForAnswer);
                }
              }

              if (parsed.streaming === false) {
                if (parsed.response) {
                  fullResponse = parsed.response;
                }
                const idx = currentResponseIndex.current;
                if (idx !== null) {
                  setChatResponses((prev) => {
                    const updated = [...prev];
                    updated[idx] = {
                      ...updated[idx],
                      answer: fullResponse,
                      chat_id: parsed.chat_id ?? updated[idx].chat_id,
                      sources: parsed.sources || [],
                    };
                    return updated;
                  });
                }
                hasStartedStreaming.current = false;
                setShowSkeleton(false);
                setQuestionLoading(false);
                streamActiveRef.active = false;
                currentResponseIndex.current = null;
              }
            } catch (err) {
              console.error("❌ Error parsing stream chunk:", err);
            }
          },
          // Server closed the stream. If we already received the final
          // (streaming === false) message, this is a normal close. Throwing
          // here prevents fetch-event-source from auto-reconnecting and
          // re-running the whole generation.
          onclose: () => {
            // Marked so the outer catch can tell this apart from a real error.
            const e: any = new Error("Stream closed");
            e.intentionalClose = true;
            throw e;
          },
          onerror: (err) => {
            console.error("💥 Stream error:", err);
            setQuestionLoading(false);
            streamActiveRef.active = false;
            currentResponseIndex.current = null;
            // Re-throw so the library stops retrying. Returning (or not
            // throwing) tells fetch-event-source to reconnect, which causes
            // the duplicate diet generation.
            throw err;
          },
        },
      );
    } catch (err: any) {
      if (!err?.intentionalClose) {
        console.error("🔥 Fetch Event Source error:", err);
      }
      setQuestionLoading(false);
      streamActiveRef.active = false;
      currentResponseIndex.current = null;
    }
  };

  const onFollowupQuestionClick = (followupQuestion: string) => {
    sendQuestion(followupQuestion);
  };

  const handleSubmit = () => {
    // your logic here
    console.log("Submit clicked!");
  };

  const onDocumentFileSelect = (event: any) => {
    const file: File = event.files[0];
    if (file) {
      const reader = new FileReader();
      if (!file.type.startsWith("application/pdf")) {
        toast.current?.show({
          severity: "warn",
          summary: "Warning",
          detail: "Please select an image file only.",
          life: 3000,
        });
        return;
      }

      reader.onloadend = () => {
        setDocumentFileName(file.name);
        if (file !== null) {
          const data = {
            File: file,
          };

          UploadDocumentFile(data);
        }
      };

      reader.readAsDataURL(file);
    } else {
      toast.current?.show({
        severity: "warn",
        summary: "Warning",
        detail: "Something went wrong.",
        life: 3000,
      });
      return;
    }
  };

  const UploadDocumentFile = (data: any) => {
    fileUpload
      .PDFUpload(data, (progress: number) => {
        setProgressForDocument(progress);
      })
      .then((res: any) => {
        try {
          if (res.status === 200) {
            toast.current?.show({
              severity: "success",
              summary: "Success",
              detail: "PDF uploaded successfully",
              life: 3000,
            });
            setUploadVisible(false);
            setDocumentFileName("");
          }
          setTimeout(() => setProgressForDocument(0), 2000);
          return res.data;
          // Redirect the user to the protected route
        } catch (error: any) {
          if (error.response && error.response.status === 401) {
            toast.current?.show({
              severity: "warn",
              summary: "Warning",
              detail: "Unauthorized",
              life: 3000,
            });
            window.location.pathname = "/";
          }
        }
      });
  };

  const onUploadDocumentClick = (rowData: any) => {
    setUploadVisible(true);
  };

  const initialValues = {
    documentUpload: "",
  };

  const formik = useFormik({
    initialValues,
    onSubmit: handleSubmit,
  });

  const hideUploadDialog = () => {
    setUploadVisible(false);
  };

  const header = (
    <div className="p-d-flex p-jc-between p-ai-center">
      <span>{resource.uploadDocumentHeader}</span>
      <Button
        icon="pi pi-times"
        className="p-button-rounded p-button-text popup-close-button"
        onClick={hideUploadDialog}
      />
    </div>
  );
  const handleCopy = async (text: string) => {
    try {
      // Convert markdown to HTML (preserve tables, bold, etc.)
      const htmlContent = marked.parse(text);

      // Create a clipboard item containing both HTML and plain text
      const clipboardItem = new ClipboardItem({
        "text/html": new Blob([htmlContent], { type: "text/html" }),
        "text/plain": new Blob([text], { type: "text/plain" }),
      });

      await navigator.clipboard.write([clipboardItem]);

      toast.current?.show({
        severity: "success",
        summary: "Copied",
        detail: "Answer copied!",
        life: 2000,
      });
    } catch (err) {
      console.error("Copy failed:", err);
      // fallback (plain text only)
      navigator.clipboard.writeText(text);
      toast.current?.show({
        severity: "warn",
        summary: "Copied (Plain)",
        detail: "Copied without formatting due to browser limits.",
        life: 2000,
      });
    }
  };

  const handleShare = async (text: string) => {
    const shareData = {
      title: "ChatBot Answer",
      text,
    };
    try {
      if (navigator.share) {
        await navigator.share(shareData);
      } else {
        navigator.clipboard.writeText(text);
        toast.current?.show({
          severity: "success",
          summary: "Link Copied",
          detail: "Sharing not supported, copied to clipboard!",
          life: 2000,
        });
      }
    } catch (err) {
      console.error("Share failed:", err);
    }
  };
  const onSavePrescription = async (
    conversationId?: string,
    chatId?: string,
  ) => {
    // const prescriptionId = protocolData?.prescriptionId;
    const userId = protocolData?.userId;
    const dietstartdate = protocolData?.dietstartdate;

    if (!userId || !conversationId || !chatId || !dietstartdate) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing data",
        detail:
          "Customer ID, conversation ID, chat ID, or diet start date missing",
        life: 3000,
      });
      return;
    }

    // const data = {
    //   prescriptionid: prescriptionId,
    //   conversationid: conversationId,
    //   chatid: chatId,
    // };
    const data = {
      userid: userId,
      conversationid: conversationId,
      chatid: chatId,
      dietstartdate,
    };

    try {
      const res: any = await protocolServices.saveDietPlan(data);

      if (res?.status === 200 && res.data?.p_response === true) {
        setChatResponses((prev) =>
          prev.map((chat) =>
            chat.chat_id === chatId && chat.conversation_id === conversationId
              ? { ...chat, isdietsaved: true }
              : chat,
          ),
        );
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: res.data.p_msg || "Diet plan saved successfully",
          life: 3000,
        });
      } else if (res?.status === 200 && res.data?.p_response === false) {
        toast.current?.show({
          severity: "warn",
          summary: "Warning",
          detail: res.data.p_msg,
          life: 3000,
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to save diet plan",
        life: 3000,
      });
    }
  };

  const onDownloadRecipe = async (chatId?: string) => {
    const userId = protocolData?.userId;

    if (!userId || !chatId) {
      toast.current?.show({
        severity: "warn",
        summary: "Missing data",
        detail: "Customer ID or chat ID missing",
        life: 3000,
      });
      return;
    }

    setDownloadingRecipeChatId(chatId);

    try {
      const resp = await fetch(
        // "https://cc4jaxi5vi.execute-api.ap-south-1.amazonaws.com/Prod/downloadrecipe",
        "https://chataiapi-dev.vedbhoomi.co.in/downloadrecipe",
        // "http://127.0.0.1:8000/downloadrecipe",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            ...authHeader(),
          },
          body: JSON.stringify({
            chat_id: chatId,
            customer_user_id: userId,
          }),
        },
      );

      if (!resp.ok) {
        throw new Error("Failed to download recipe");
      }

      const data = await resp.json();

      if (data.recipe_document) {
        window.open(data.recipe_document, "_blank");
        toast.current?.show({
          severity: "success",
          summary: "Success",
          detail: data.message || "Recipe downloaded successfully",
          life: 3000,
        });
      } else {
        toast.current?.show({
          severity: "warn",
          summary: "No Recipe",
          detail: data.message || "No recipe found",
          life: 3000,
        });
      }
    } catch (error: any) {
      toast.current?.show({
        severity: "error",
        summary: "Error",
        detail: "Failed to download recipe",
        life: 3000,
      });
    } finally {
      setDownloadingRecipeChatId(null);
    }
  };

  const handlePrint = (question: string, answer: string) => {
    const printWindow = window.open("", "_blank");
    if (!printWindow) return;

    printWindow.document.write(`
    <html>
      <head>
        <title>Chat Print</title>
        <style>
          body {
            font-family: 'Noto Sans', sans-serif;
            padding: 20px;
            color: #333;
          }
          h2 { color: #d69135; }
          .question { font-weight: bold; margin-bottom: 8px; }
          .answer { margin-top: 10px; line-height: 1.6; }
        </style>
      </head>
      <body>
        <h2>Chat Response</h2>
        <div class="question">Q: ${question}</div>
        <div class="answer">${answer}</div>
      </body>
    </html>
  `);
    printWindow.document.close();
    printWindow.print();
  };

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        fontFamily: "'Noto Sans', 'Noto Sans Devanagari', sans-serif",
        background: theme.background,
        color: theme.textPrimary,
        overflow: "hidden",
      }}
    >
      <Toast ref={toast} />

      {/* Sidebar */}
      <div
        className="chatbot-sidebar"
        style={{
          background: theme.backgroundAlt,
          borderRight: `1px solid ${theme.border}`,
        }}
      >
        <div
          style={{
            display: "flex",
            alignItems: "center",
            gap: "0.75rem",
            marginBottom: "1.5rem",
          }}
        >
          <Button
            className="orange-btn back-btn"
            icon="pi pi-chevron-left"
            onClick={onBackButtonClick}
          />
          <button
            onClick={() => startNewConversation()}
            style={{
              flex: 1,
              padding: "0.45rem 0.75rem",
              background: theme.primary,
              boxShadow: "0 4px 12px rgba(245,133,0,0.25)",
              color: "#fff",
              border: "none",
              borderRadius: "8px",
              cursor: "pointer",
              fontWeight: 600,
              fontSize: "13px",
              letterSpacing: "0.2px",
              transition: "0.25s ease",
              height: "36px",
            }}
            onMouseOut={(e) =>
              (e.currentTarget.style.background =
                "linear-gradient(135deg, #f58500, #f58500)")
            }
          >
            + New Chat
          </button>
        </div>
        {Object.values(groupedConversations).flat().length === 0 && (
          <p
            style={{ color: "#a48f7b", textAlign: "center", marginTop: "2rem" }}
          >
            No history available
          </p>
        )}

        {Object.entries({
          today: "Today",
          thisWeek: "This Week",
          thisMonth: "This Month",
          lastMonth: "Last Month",
          pastMonths: "Past Months",
        }).map(([key, label]) => {
          const list = groupedConversations[key] || [];
          if (list.length === 0) return null;

          return (
            <div key={key} style={{ marginBottom: "1rem" }}>
              <div
                style={{
                  cursor: "pointer",
                  fontWeight: 700,
                  marginBottom: "6px",
                  color: "#754b0e",
                  fontSize: "14.5px",
                  textTransform: "uppercase",
                  letterSpacing: "0.3px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
                onClick={() =>
                  setOpenGroups((prev) => ({ ...prev, [key]: !prev[key] }))
                }
              >
                <span>{label}</span>
                <span style={{ fontSize: "15px", color: "#b48439" }}>
                  {openGroups[key] ? "▼" : "▶"}
                </span>
              </div>

              {openGroups[key] && (
                <div
                  style={{
                    backgroundColor: "#fff",
                    borderRadius: "10px",
                    boxShadow: "inset 0 0 6px rgba(0,0,0,0.05)",
                    padding: "6px 10px",
                  }}
                >
                  {list.map((conv: any) => {
                    const isOpen = selectedConversationId === conv.convId;
                    return (
                      <div
                        key={conv.convId}
                        onClick={() => {
                          setSelectedConversationId(conv.convId);
                          setIsNewChatStarted(false);
                          navigate(`/chatBot/${conv.convId}`);
                        }}
                        style={{
                          background: isOpen
                            ? "rgba(224, 165, 83, 0.15)"
                            : "transparent",
                          padding: "8px 10px",
                          borderRadius: "8px",
                          cursor: "pointer",
                          marginBottom: "4px",
                          transition: "all 0.2s ease",
                        }}
                        onMouseOver={(e) =>
                          (e.currentTarget.style.background = isOpen
                            ? "rgba(224,165,83,0.3)"
                            : "rgba(224,165,83,0.08)")
                        }
                        onMouseOut={(e) =>
                          (e.currentTarget.style.background = isOpen
                            ? "rgba(224,165,83,0.15)"
                            : "transparent")
                        }
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                          }}
                        >
                          <span
                            style={{
                              fontWeight: 500,
                              color: "#3a2b10",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              maxWidth: "150px",
                            }}
                            title={conv.header}
                          >
                            {truncateText(conv.header, 40)}
                          </span>
                          <span style={{ fontSize: "11px", color: "#999" }}>
                            {conv.date}
                          </span>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          );
        })}
      </div>
      <div
        style={{
          flex: 1,
          display: "flex",
          flexDirection: "column",
          position: "relative",
          overflow: "hidden",
        }}
      >
        {/* <div className="flex align-items-center"> */}
        <>
          <div
            className="flex w-full"
            style={{
              padding: "14px",
              display: "flex",
              alignItems: "center",
              gap: "16px",
              flexWrap: "wrap",
            }}
          >
            {/* Adding the below div and in it the order in style to put Documents at the end even when the first 3 fields are not their */}
            <div
              style={{
                order: 1,
                flex: "1 1 65%",
                display: "flex",
                flexWrap: "wrap",
                gap: "16px",
              }}
            >
              {protocolData && (
                <>
                  {/* Patient Name */}
                  <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                    <div className="inline-field">
                      <span className="inline-label">Patient Name:</span>
                      <span
                        className="inline-value"
                        title={protocolData.customer}
                      >
                        {protocolData.customer || "-"}
                      </span>
                    </div>
                  </div>

                  {/* Prescription */}
                  {/* <div style={{ flex: "1 1 220px", minWidth: 0 }}>
                    <div className="inline-field">
                      <span className="inline-label">Prescription:</span>
                      <span
                        className="inline-value"
                        title={protocolData.prescription}
                      >
                        {protocolData.prescription || "-"}
                      </span>
                    </div>
                  </div> */}

                  {/* Date of Prescription */}
                  <div style={{ flex: "1 1 260px", minWidth: 0 }}>
                    <div className="inline-field">
                      <span className="inline-label">Diet Start Date:</span>
                      <span className="inline-value">
                        {protocolData.dietstartdate || "-"}
                      </span>
                    </div>
                  </div>
                </>
              )}
            </div>

            {/* Documents */}
            <div
              style={{
                order: 2,
                flex: "1 1 260px",
                minWidth: 260,
                display: "flex",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontSize: "15px",
                  fontWeight: 700,
                  color: "#8a5c22",
                  whiteSpace: "nowrap",
                  marginRight: "6px",
                }}
              >
                Documents:
              </span>

              <MultiSelect
                value={selectedDocuments}
                onChange={(e) => {
                  const nextValue = e.value;

                  if (nextValue.length > 5) {
                    toast.current?.show({
                      severity: "warn",
                      summary: "Limit reached",
                      detail: "You can select up to 5 documents only",
                      life: 3000,
                    });
                    setSelectedDocuments(selectedDocuments);
                    return;
                  }
                  setSelectedDocuments(nextValue);
                }}
                options={documentOptions}
                optionLabel="name"
                placeholder="Select Documents"
                display="chip"
                filter
                filterBy="name"
                style={{
                  height: "42px",
                  width: "100%",
                  maxWidth: "220px",
                  minWidth: "180px",
                  borderRadius: "10px",
                  border: "1px solid #e1cfa8",
                  fontSize: "14px",
                  backgroundColor: "#ffffff",
                }}
                panelClassName="custom-dropdown-panel"
              />
            </div>
          </div>
        </>
        {loadingSpinnerLayout && (
          <div
            style={{
              flex: 1,
              height: "calc(100vh - 160px)",
              display: "flex",
              position: "relative",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#fff",
            }}
          >
            <div style={{ textAlign: "center" }}>
              <ProgressSpinner
                style={{ width: "48px", height: "48px" }}
                strokeWidth="4"
                animationDuration=".8s"
              />
              <div
                style={{
                  marginTop: "12px",
                  fontSize: "14px",
                  fontWeight: 500,
                  color: "#8a5c22",
                }}
              >
                Loading chat history…
              </div>
            </div>
          </div>
        )}

        {!loadingSpinnerLayout && (
          <div
            ref={chatContainerRef}
            style={{
              flex: 1,
              overflowY: "auto",
              padding: "1.5rem",
              backgroundColor: "#fff",
              paddingBottom: "160px",
              height: "calc(100vh - 70px)",
              boxSizing: "border-box",
            }}
          >
            {(selectedConversationId
              ? chatResponses
                  .filter(
                    (chat) => chat.conversation_id === selectedConversationId,
                  )
                  .sort(
                    (a, b) =>
                      new Date(a.created_at || "").getTime() -
                      new Date(b.created_at || "").getTime(),
                  )
              : chatResponses.sort(
                  (a, b) =>
                    new Date(a.created_at || "").getTime() -
                    new Date(b.created_at || "").getTime(),
                )
            ).map((response, index, arr) => {
              const trimmedAnswer = (response.answer || "").trim();
              let mainAnswer = trimmedAnswer;
              let followUpQuestions: string[] = [];

              if (trimmedAnswer.includes("$$FollowupQuestions$$")) {
                const answerParts = trimmedAnswer.split(
                  "$$FollowupQuestions$$",
                );
                mainAnswer = answerParts[0];
                followUpQuestions = answerParts[1]
                  ? answerParts[1]
                      .trim()
                      .split("\n")
                      .filter((q) => q)
                  : [];
              }

              const isLastAnswer = index === arr.length - 1;

              return (
                <div
                  id={`chat-${response.conversation_id ?? index}-${index}`}
                  key={index}
                  className={`col-12 ${
                    isLastAnswer && questionloading
                      ? "last-answer-block"
                      : "question-answer-block"
                  } mt-3`}
                >
                  <div className="ans-text-flex">
                    <span className="me-1 avtar border-rounded">VB</span>
                    <span
                      className="question-block"
                      style={{
                        background: theme.primarySoft,
                        padding: "10px 14px",
                        borderRadius: "12px",
                        color: theme.textPrimary,
                        fontWeight: 600,
                      }}
                    >
                      <b>{response.question}</b>
                    </span>
                  </div>

                  <div style={{ position: "relative" }}>
                    <img
                      src={AnswerIcon}
                      className="me-2"
                      height={45}
                      style={{ position: "absolute", borderRadius: "50px" }}
                    />

                    {/* Copy / Share / Print buttons */}
                    <div className="chat-toolbar">
                      <button
                        className="chat-tool-btn"
                        title="Copy Answer"
                        onClick={() => handleCopy(mainAnswer)}
                      >
                        <i className="pi pi-copy"></i>
                      </button>

                      {/* <button
                        className="chat-tool-btn"
                        title="Share Answer"
                        onClick={() => handleShare(mainAnswer)}
                      >
                        <i className="pi pi-share-alt"></i>
                      </button> */}
                      {hasTable(mainAnswer) &&
                        !(isLastAnswer && questionloading) && (
                          <button
                            onClick={() =>
                              onSavePrescription(
                                response.conversation_id,
                                response.chat_id,
                              )
                            }
                            disabled={response.isdietsaved === true}
                            style={{
                              flex: 1,
                              padding: "0.45rem 0.75rem",
                              background: response.isdietsaved
                                ? "#b5b5b5"
                                : theme.primary,
                              boxShadow: response.isdietsaved
                                ? "none"
                                : "0 4px 12px rgba(245,133,0,0.25)",
                              color: response.isdietsaved ? "#f0f0f0" : "#fff",
                              border: "none",
                              borderRadius: "8px",
                              cursor: response.isdietsaved
                                ? "not-allowed"
                                : "pointer",
                              fontWeight: 600,
                              fontSize: "13px",
                              letterSpacing: "0.2px",
                              transition: "0.25s ease",
                              height: "36px",
                              opacity: response.isdietsaved ? 0.7 : 1,
                            }}
                            onMouseOver={(e) => {
                              if (!response.isdietsaved) {
                                e.currentTarget.style.background =
                                  "linear-gradient(135deg, #d97500, #b85f00)";
                                e.currentTarget.style.boxShadow =
                                  "0 6px 16px rgba(245,133,0,0.4)";
                                e.currentTarget.style.transform =
                                  "translateY(-1px)";
                              }
                            }}
                            onMouseOut={(e) => {
                              if (!response.isdietsaved) {
                                e.currentTarget.style.background =
                                  "linear-gradient(135deg, #f58500, #f58500)";
                                e.currentTarget.style.boxShadow =
                                  "0 4px 12px rgba(245,133,0,0.25)";
                                e.currentTarget.style.transform =
                                  "translateY(0)";
                              }
                            }}
                          >
                            {response.isdietsaved
                              ? "Diet saved"
                              : "Add to diet"}
                          </button>
                        )}
                      {hasTable(mainAnswer) &&
                        !(isLastAnswer && questionloading) && (
                          <button
                            onClick={() => onDownloadRecipe(response.chat_id)}
                            disabled={
                              downloadingRecipeChatId === response.chat_id
                            }
                            style={{
                              flex: 1,
                              padding: "0.45rem 0.75rem",
                              background:
                                downloadingRecipeChatId === response.chat_id
                                  ? "#ccc"
                                  : theme.primary,
                              boxShadow:
                                downloadingRecipeChatId === response.chat_id
                                  ? "none"
                                  : "0 4px 12px rgba(245,133,0,0.25)",
                              color: "#fff",
                              border: "none",
                              borderRadius: "8px",
                              cursor:
                                downloadingRecipeChatId === response.chat_id
                                  ? "not-allowed"
                                  : "pointer",
                              fontWeight: 600,
                              fontSize: "13px",
                              letterSpacing: "0.2px",
                              transition: "0.25s ease",
                              width: "185px",
                              height: "36px",
                            }}
                            onMouseOver={(e) => {
                              if (
                                downloadingRecipeChatId !== response.chat_id
                              ) {
                                e.currentTarget.style.background =
                                  "linear-gradient(135deg, #d97500, #b85f00)";
                                e.currentTarget.style.boxShadow =
                                  "0 6px 16px rgba(245,133,0,0.4)";
                                e.currentTarget.style.transform =
                                  "translateY(-1px)";
                              }
                            }}
                            onMouseOut={(e) => {
                              if (
                                downloadingRecipeChatId !== response.chat_id
                              ) {
                                e.currentTarget.style.background =
                                  "linear-gradient(135deg, #f58500, #f58500)";
                                e.currentTarget.style.boxShadow =
                                  "0 4px 12px rgba(245,133,0,0.25)";
                                e.currentTarget.style.transform =
                                  "translateY(0)";
                              }
                            }}
                          >
                            {downloadingRecipeChatId === response.chat_id
                              ? "Generating..."
                              : "Generate Recipe"}
                          </button>
                        )}
                    </div>

                    <div className="p-text mt-4" style={{ marginLeft: "50px" }}>
                      <div
                        style={{
                          position: "relative",
                          background: theme.background,
                          borderLeft: `4px solid ${theme.primary}`,
                          borderRadius: "10px",
                          fontSize: "16px",
                          lineHeight: "1.75",
                          fontWeight: 500,
                        }}
                      >
                        {isLastAnswer && questionloading && showSkeleton && (
                          <div
                            style={{
                              position: "relative",
                              background: theme.background,
                              borderLeft: `3px solid ${theme.primary}`,
                              borderRadius: "10px",
                              fontSize: "16px",
                              lineHeight: "1.75",
                              fontWeight: 500,
                            }}
                          >
                            <Skeleton height="12px" className="mb-2" />
                            <Skeleton width="60%" height="12px" />
                          </div>
                        )}
                        <ReactMarkdown
                          remarkPlugins={[remarkGfm]}
                          components={{
                            li: ({ node, ...props }) => (
                              <li
                                style={{
                                  fontSize: "16px",
                                  marginBottom: "8px",
                                }}
                                {...props}
                              />
                            ),
                            p: ({ node, ...props }) => (
                              <p
                                style={{
                                  fontSize: "16px",
                                  marginBottom: "8px",
                                }}
                                {...props}
                              />
                            ),
                            table: ({ node, ...props }) => (
                              <div
                                className="markdown-table-wrapper"
                                style={{
                                  overflowX: "auto",
                                  marginBottom: "1.2rem",
                                  borderRadius: "10px",
                                  border: "1px solid #e6d8bf",
                                  boxShadow: "0 4px 10px rgba(0,0,0,0.04)",
                                  background: "#fff",
                                }}
                              >
                                <table
                                  style={{
                                    borderCollapse: "collapse",
                                    width: "100%",
                                    minWidth: "500px",
                                    tableLayout: "fixed",
                                  }}
                                  {...props}
                                />
                              </div>
                            ),

                            tr: ({ node, ...props }) => (
                              <tr
                                style={{
                                  borderBottom: "1px solid #eee",
                                }}
                                {...props}
                              />
                            ),

                            thead: ({ node, ...props }) => (
                              <thead
                                style={{
                                  position: "sticky",
                                  top: 0,
                                  zIndex: 1,
                                }}
                                {...props}
                              />
                            ),

                            th: ({ node, ...props }) => (
                              <th
                                style={{
                                  padding: "10px",
                                  border: "1px solid #e0d7c6",
                                  backgroundColor: "#f9f5ef",
                                  textAlign: "left",
                                  fontWeight: 700,
                                  fontSize: "15px",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  verticalAlign: "top",
                                  overflowWrap: "anywhere",
                                }}
                                {...props}
                              />
                            ),
                            td: ({ node, ...props }) => (
                              <td
                                style={{
                                  padding: "10px",
                                  border: "1px solid #e0d7c6",
                                  fontSize: "15px",
                                  lineHeight: "1.6",
                                  whiteSpace: "normal",
                                  wordBreak: "break-word",
                                  verticalAlign: "top",
                                  overflowWrap: "anywhere",
                                }}
                                {...props}
                              />
                            ),
                          }}
                        >
                          {mainAnswer || " "}
                        </ReactMarkdown>
                        {/* Sources hidden: it arrives in the final stream
                            message and delaying it was holding back the
                            "Add to diet" button. Uncomment to restore. */}
                        {/* {response.sources && response.sources.length > 0 && (
                          <div
                            style={{
                              marginTop: "8px",
                              marginLeft: "7px",
                              fontSize: "13px",
                              color: "#6b5b4a",
                              borderTop: "1px dashed #e0cfa2",
                              paddingTop: "6px",
                            }}
                          >
                            <strong>Sources:</strong>
                            <ul
                              style={{
                                marginTop: "4px",
                                paddingLeft: "18px",
                                marginLeft: "10px",
                              }}
                            >
                              {response.sources.map((src, i) => (
                                <li key={i}>📄 {src.document_name}</li>
                              ))}
                            </ul>
                          </div>
                        )} */}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        )}

        {(isNewChatEmpty || hasNoHistory) && (
          <div
            style={{
              position: "absolute",
              top: "70px",
              left: 0,
              right: 0,
              bottom: "120px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "#fff",
              padding: "24px",
              zIndex: 1,
            }}
          >
            <div
              style={{
                maxWidth: "650px",
                padding: "48px 44px",
                borderRadius: "24px",
                textAlign: "center",
                background: "linear-gradient(180deg, #fffdf7 0%, #ffffff 100%)",
                boxShadow: "0 16px 38px rgba(0,0,0,0.11)",
                animation: "fadeInUp 0.4s ease-out",
              }}
            >
              <div
                style={{
                  width: "120px",
                  height: "120px",
                  margin: "0 auto 24px",
                  borderRadius: "50%",
                  background: "#fff3d6",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  boxShadow: "0 9px 20px rgba(0,0,0,0.13)",
                }}
              >
                <img
                  src={AnswerIcon}
                  alt="Vedbhoomi"
                  style={{ width: "70px" }}
                />
              </div>
              <h2
                style={{
                  fontSize: "28px",
                  fontWeight: 700,
                  color: "#754b0e",
                  marginBottom: "14px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "8px",
                  whiteSpace: "nowrap",
                }}
              >
                <span>Welcome to Vedbhoomi Support Bot!</span>
                <span style={{ fontSize: "26px", lineHeight: 1 }}>🌿</span>
              </h2>

              <p
                style={{
                  fontSize: "18px",
                  color: "#6b5b4a",
                  lineHeight: 1.75,
                  marginBottom: "20px",
                }}
              ></p>
              <p
                style={{
                  fontSize: "17px",
                  color: "#6b5b4a",
                  lineHeight: 1.7,
                  marginBottom: "26px",
                  fontWeight: 500,
                }}
              >
                🥗🌿 Your personal Ayurvedic assistant for diet-focused
                guidance, helping you with doshas, food choices, and
                personalized diet plans.
              </p>

              <div
                style={{
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "14px",
                }}
              >
                {[
                  "Give me a diet plan for Vata dosha",
                  "Foods to avoid for cough",
                  "Kapha diet for weight balance",
                ].map((text) => (
                  <span
                    key={text}
                    style={{
                      padding: "12px 22px",
                      borderRadius: "24px",
                      background: "#fff1cc",
                      color: "#8a5c22",
                      fontSize: "15px",
                      fontWeight: 600,
                      cursor: "text",
                      userSelect: "none",
                    }}
                  >
                    {text}
                  </span>
                ))}
              </div>
            </div>
          </div>
        )}
        <div
          style={{
            background: theme.backgroundAlt,
            padding: "10px 14px",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "10px",
              maxWidth: "780px",
              margin: "0 auto",
              width: "100%",
            }}
          >
            <textarea
              name="question"
              onChange={onQuestionChange}
              value={question}
              ref={textareaRef}
              className="form-control"
              placeholder="Ask me anything about doshas and its diet..."
              maxLength={2000}
              onKeyDown={onEnterClick}
              style={{
                resize: "none",
                border: `1px solid ${theme.border}`,
                fontSize: "18px",
                boxShadow: "inset 0 2px 4px rgba(0,0,0,0.05)",
                minHeight: "80px",
                maxHeight: "120px",
                padding: "14px 18px",
                fontFamily: "'Noto Sans', 'Noto Sans Devanagari', sans-serif",
                fontWeight: 400,
                lineHeight: "28px",
                letterSpacing: "0.1px",
                borderRadius: "10px",
                flex: 1,
              }}
            />

            <img
              src={CommunicationIcon}
              onClick={() => sendQuestion(question)}
              alt="Send"
              style={{
                width: 38,
                height: 38,
                cursor: "pointer",
                borderRadius: "50%",
                padding: "6px",
                background: "#f0c27b",
                boxShadow: "0 2px 6px rgba(0,0,0,0.15)",
                transition: "0.25s ease",
              }}
              onMouseOver={(e) => {
                e.currentTarget.style.background = "#e0a95a";
                e.currentTarget.style.boxShadow =
                  "0 4px 12px rgba(245,133,0,0.35)";
                e.currentTarget.style.transform = "scale(1.08)";
              }}
              onMouseOut={(e) => {
                e.currentTarget.style.background = "#f0c27b";
                e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.15)";
                e.currentTarget.style.transform = "scale(1)";
              }}
            />
          </div>

          <span
            className="info-msg"
            style={{
              display: "block",
              fontSize: "11px",
              color: "#8a5c22",
              marginTop: "4px",
              textAlign: "center",
            }}
          >
            Support Bot can make mistakes. Check important info.
          </span>
        </div>
      </div>

      <Dialog
        className="popup popup-card-layout"
        header={header}
        draggable={false}
        visible={uploadVisible}
        style={{ width: "70vw" }}
        onHide={hideUploadDialog}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className="card-wrapper">
            <div className="flex mb-2">
              <div className="col-4 relative">
                <label
                  htmlFor="documentUpload"
                  className="block text-900 font-medium mb-2"
                >
                  {resource.documentUpload} <span className="text-red">*</span>
                </label>
                <div className="flex flex-column "></div>
                <div className="flex">
                  <InputText
                    id="documentUpload"
                    type="text"
                    placeholder="Select document"
                    className="fileinput ml-1 "
                    value={documentFileName}
                    onChange={formik.handleChange}
                    tabIndex={1}
                  />
                  <FileUpload
                    mode="basic"
                    accept="application/pdf"
                    auto
                    chooseLabel="Select"
                    className=" flex justify-content-center  fileselectbtn"
                    style={{ height: "40px" }}
                    onSelect={onDocumentFileSelect}
                  />
                </div>
              </div>
            </div>
          </div>
        </form>
      </Dialog>
    </div>
  );
}
